import { Injectable } from '@angular/core';
import {
  ACTION_NAMES,
  ANALYTICS_EVENTS,
  EVENT_CLICK_TYPE,
  USER_LOGGED_IN_STATUS
} from '../../../constants/utils';
import {
  adobeClickEventAnalyticsMocks,
  adobeModalLoadLoginAnalyticsMocks,
  adobePageLoadLoginAnalyticsMocks
} from '../../../mocks/utils';
import {
  CustomEventErrorAnalytics,
  ModalLoadLoginAnalytics,
  PageLoadLoginAnalytics
} from '../../../models/utils';
import { AdobeDataLayerServiceExtended } from './adobe-data-layer-extended';
@Injectable({
  providedIn: 'root'
})
export class AdobeDataLayerServiceSuperExtended extends AdobeDataLayerServiceExtended {
  updateAnalyticsLoginModal(
    name: string,
    pageSection: string,
    button: boolean
  ): void {
    let data = adobeClickEventAnalyticsMocks;
    const buttonText = button ? ACTION_NAMES.BUTTON : ACTION_NAMES.LINK;
    const action = `${pageSection}:${name}:${buttonText}`;
    data = {
      ...data,
      event: ANALYTICS_EVENTS.CLICK,
      event_detail: action,
      click: {
        name: name,
        type: button ? EVENT_CLICK_TYPE.BUTTON : EVENT_CLICK_TYPE.LINK,
        page_section: pageSection,
        action: action
      },
      user: {
        attributes: {
          is_logged_in: USER_LOGGED_IN_STATUS.UNAUTHENTICATED,
          login_state: USER_LOGGED_IN_STATUS.COLD
        }
      }
    };
    this.analytics.setAnalytics(data);
  }

  populatePageAssets(
    legacyPageName: string,
    langCode: string,
    countryCode: string,
    durationSec: string,
    viewPage: string
  ): void {
    const pathname = window.document.location.pathname;
    const parts = pathname?.split('/');
    const lastPart = parts && parts.length > 0 ? parts[parts.length - 1] : '';
    this.getLastPageTitle();
    const data: PageLoadLoginAnalytics = {
      ...adobePageLoadLoginAnalyticsMocks,
      event_detail: `${viewPage}:${lastPart}:page load`,
      page: {
        info: {
          ...adobePageLoadLoginAnalyticsMocks.page.info,
          legacy_page_name: `Login:${legacyPageName}`,
          page_name: `dal:skymiles:${lastPart}`,
          page_url: pathname,
          page_type: 'login',
          page_load_time: Number(durationSec),
          section: 'skymiles',
          sub_section: lastPart,
          country: countryCode,
          language: langCode,
          previous_page_name: this.previousPageName,
          previous_page_url: this.previousUrl,
          sys_env: this.checKSysEnv()
        }
      },
      user: {
        attributes: {
          is_logged_in: USER_LOGGED_IN_STATUS.UNAUTHENTICATED,
          login_state: USER_LOGGED_IN_STATUS.COLD
        }
      }
    };
    this.analytics.setLoginAnalytics(data);
  }

  populateModalAssets(
    subPageName: string,
    langCode: string,
    countryCode: string
  ): void {
    const pathname = window.document.location.pathname;
    const parts = pathname?.split('/');
    const sub_section = this.getValue(0, 1, parts);
    const section = this.getValue(1, 2, parts);
    const pageValue = this.checkHomePage(section, sub_section);

    const data: ModalLoadLoginAnalytics = {
      ...adobeModalLoadLoginAnalyticsMocks,
      event_detail: `${subPageName}:modal load`,
      page: {
        info: {
          ...adobeModalLoadLoginAnalyticsMocks.page.info,
          legacy_page_name: this.getLegacyPageName(pageValue?.section),
          page_name: `dal:${pageValue.pageName}`,
          section: pageValue.section,
          sub_section: pageValue.sub_section,
          subpage_name: subPageName,
          country: countryCode,
          language: langCode,
          sys_env: this.checKSysEnv()
        }
      }
    };
    this.analytics.setModalAnalytics(data);
  }

  setLoginAccountRecoveryGlobalError(
    viewPage: string,
    errorId?: string,
    errorMessage?: string
  ): void {
    const data: CustomEventErrorAnalytics = {
      event: ANALYTICS_EVENTS.ERROR,
      event_detail: `${viewPage}:login:${USER_LOGGED_IN_STATUS.LOGIN_FAILURE}`,
      user: {
        attributes: {
          is_logged_in: USER_LOGGED_IN_STATUS.UNAUTHENTICATED,
          login_method: 'username',
          login_state: USER_LOGGED_IN_STATUS.COLD
        }
      },
      error: {
        type: 'login error',
        code: errorId ? errorId : '',
        message: errorMessage ? errorMessage : ''
      }
    };
    this.analytics.setErrorAnalytics(data);
  }
}
